"use strict";
//=======================================
// Inventory Helper
//=======================================

// Shopify object required
if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}

Shopify.InvtHelper = {
  Util: {
    getUrlParameter: function(sParam) {
      let sPageURL = window.location.search.substring(1);
      let sURLVariables = sPageURL.split('&');
      let sParameterName;
      for (let i=0; i<sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
      return false;
    },
    formatPhoneNumber: function(str) {
      const cleaned = ('' + str).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '1-(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null;
    }
  },
  GoogleGeo: {
    _APIKey: 'AIzaSyAGrgD-RcdRlOlta7ObDyWd12Duo0750wE',
    lookupLatLng: async function(zip) {
      let response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zip},US&key=${this._APIKey}`);
      if (!response.ok) {
        throw new Error(`Google api error: ${response.status}`);
      }
      let result = await response.json();
      return result;
    },
    lookupZip: async function(latitude, longitude) {
      let response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${this._APIKey}&result_type=locality|postal_code`);
      if (!response.ok) {
        throw new Error(`Google api error: ${response.status}`);
      }
      let result = await response.json();
      return result;
    },
  },
  Cookie: {
    _Exp: 7,
  },
  Pickup: {
    _AuthToken: 'Bearer 72NX5RFN0Q0C78NX303RGN1C073D98UR2938P2897478239Y17FY8921L09247F2',
    getATPDate: async function(zip, sku, quantity) {
      const settings = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': this._AuthToken,
        },
        body: `zipCode=${zip}&sku=${sku}&quantity=${quantity}`
      };
      let response = await fetch(`https://mw-shop.endertech.net/api/product-delivery-date`, settings);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      let result = await response.json();
      return result;
    },
    getAvailableDeliveryDate: function() {
      const zip = $.cookie('location_zip');
      if (!zip) { return; }
  
      const id = Shopify.InvtHelper.Util.getUrlParameter('variant');
      const sku = Shopify.InvtHelper.PageProduct._variantsIdSku[ id ];
  
      const $q = $('#quantity');
      if (!$q.length) { return; }
      const qtyNum = $q.val();
      const qty = qtyNum.toString();

      console.log(`getATPDate(${zip}, ${sku}, ${qty})`);
      //return;  // do not call getATPDate while development
      return Shopify.InvtHelper.Pickup.getATPDate(zip, sku, qty);
    },
  },
  Header: {
    // Set zip automatically
    showLoadingAddress: function() {
      const $t = $('.user-location');
      if (!$t.length) { return; }
      $t.html('Setting location...');
    },
    showInitialText: function() {
      const $t = $('.user-location');
      if (!$t.length) { return; }
      $t.html('Set ZIP');
    },
    showErrorText: function(text) {
      const $f = $('#user-zip-entry-form');
      const $m = $('#user-zip-entry-form .error-message');
      if (!$f.length || !$m.length) { return; }
      $f.addClass('has-error');
      $m.html(`<span class="zip-error">${text}</span>`);
    },
    findZipFromLatLng: function(latitude, longitude) {
      const exp = Shopify.InvtHelper.Cookie._Exp;

      $.cookie('location_latitude', latitude, { path: '/', expires: exp });
      $.cookie('location_longitude', longitude, { path: '/', expires: exp });

      this.showLoadingAddress();
      Shopify.InvtHelper.GoogleGeo.lookupZip(latitude, longitude)
        .then((response) => {
          const found = response.results.find(entry => entry.types && entry.types.includes('postal_code'));
          if (!found) {
            throw new Error('postal_code not found');
          }
          if (!found.address_components) {
            throw new Error('address_components not found');
          }
          const locality = found.address_components.find(component => component.types && component.types.includes('locality'));
          const state = found.address_components.find(component => component.types && component.types.includes('administrative_area_level_1'));
          const zip = found.address_components.find(component => component.types && component.types.includes('postal_code'));
          if (!locality.short_name || !state.short_name || !zip.short_name) {
            throw new Error('locality or state or zip not found');
          }
          const address = `${locality.short_name} ${state.short_name} ${zip.short_name}`;
  
          $.cookie('location_address', address, { path: '/', expires: exp });
          $.cookie('location_zip', zip.short_name, { path: '/', expires: exp });
  
          this.showAddress(address);
          if (Shopify.InvtHelper.PageProduct._isPageProduct) {
            Shopify.InvtHelper.PageProduct.showAddress(address);
            Shopify.InvtHelper.PageProduct.showZip(zip.short_name);
            Shopify.InvtHelper.PageProduct.setLocations();
            Shopify.InvtHelper.PurchasingOptions.updateDisabledMessageWithZip();
          }
        })
        .catch((e) => {
          console.log(e);
          this.showInitialText();
        });
    },
    // Set zip manually
    showAddress: function(text) {
      const $f = $('#user-zip-entry-form');
      if ($f.length) {
        $f.removeClass('has-error');
      }
      const $ul = $('.user-location');
      if ($ul.length) {
        $ul.html( text );
      }
      const $i = $('#user-location-manual-input');
      const zip = $.cookie('location_zip');
      if ($i.length && zip) {
        $i.attr('placeholder', zip);
      }
    },
    showLoadingZip: function() {
      const $i = $('.user-location-updating-icon');
      if (!$i.length) { return; }
      $i.fadeTo(300, 1);
    },
    hideLoadingZip: function() {
      const $i = $('.user-location-updating-icon');
      if (!$i.length) { return; }
      $i.fadeTo(300, 0);
    },
    findLatLngFromZip: function(zip) {
      const exp = Shopify.InvtHelper.Cookie._Exp;
      this.showLoadingZip();
      if (Shopify.InvtHelper.PageProduct._isPageProduct) {
        Shopify.InvtHelper.PageProduct.showLoadingZip();
      }
      Shopify.InvtHelper.GoogleGeo.lookupLatLng(zip)
        .then((response) => {
          const found = response.results.find(entry => entry.types && entry.types.includes('postal_code'));
          if (!found) {
            throw new Error('postal_code not found');
          }
          if (!found.geometry || !found.geometry.location) {
            throw new Error('geometry not found');
          }
          const latitude = found.geometry.location.lat;
          const longitude = found.geometry.location.lng;
          if (!found.address_components) {
            throw new Error('address_components not found');
          }
          const locality = found.address_components.find(component => component.types && component.types.includes('locality'));
          const state = found.address_components.find(component => component.types && component.types.includes('administrative_area_level_1'));
          if (!locality.short_name || !state.short_name) {
            throw new Error('locality or state not found');
          }
          const address = `${locality.short_name} ${state.short_name} ${zip}`;
  
          $.cookie('location_latitude', latitude, { path: '/', expires: exp });
          $.cookie('location_longitude', longitude, { path: '/', expires: exp });
          $.cookie('location_address', address, { path: '/', expires: exp });
          $.cookie('location_zip', zip, { path: '/', expires: exp });
  
          this.showAddress(address);
          this.hideLoadingZip();

          // SUCCESS chain call
          if (Shopify.InvtHelper.PageProduct._isPageProduct) {
            Shopify.InvtHelper.PageProduct.showAddress(address);
            Shopify.InvtHelper.PageProduct.showZip(zip);
            Shopify.InvtHelper.PageProduct.hideLoadingZip();
            Shopify.InvtHelper.PageProduct.updateLocations();
            Shopify.InvtHelper.PurchasingOptions.updateDisabledMessageWithZip();
          }
      })
        .catch((e) => {
          console.log(e);
          switch(e.message) {
            case 'postal_code not found':
              this.showErrorText(`${zip} is not a valid Zip code. Please try again.`);
              break;
            case 'geometry not found':
            case 'address_components not found':
            case 'locality or state not found':
            default:
              this.showErrorText(`${e.message}. Entered value: ${zip}`);
              break;
          }
          this.hideLoadingZip();
          if (Shopify.InvtHelper.PageProduct._isPageProduct) {
            Shopify.InvtHelper.PageProduct.hideLoadingZip();
          }
        });
    },
    initInputRestriction: function(e) {
      const $i = $('#user-location-manual-input');
      if (!$i.length) { return };  // UI elemnets not found
      // keypress handler
      $i.on('keypress', (e) => {  // use arrow func to bind this
        // remove error css class if exists
        const $f = $('#user-zip-entry-form');
        if ($f.length) {
          $f.removeClass('has-error');
        }
        // evaluate keycode
        const keycode = (e.keyCode ? e.keyCode : e.which);
        if ((keycode != 13) && String.fromCharCode(keycode).match(/[^0-9]/g)) {
          return false;  // not Enter key and not numeric
        }
        if (keycode != '13') { return; }  // simply return if numeric
        // the submit handler takes care the rest of event flow
      });
    },
    initSubmit: function(e) {
      // override form submission
      const $f = $('#user-zip-entry-form');
      const $i = $('#user-location-manual-input');
      if (!$f.length || !$i.length) { return };  // UI elemnets not found
      // submit handler
      $f.submit((e) => {  // use arrow func to bind this
        e.preventDefault();
        const zip = $i.val();
        this.findLatLngFromZip(zip);
      });
    },
  },
  PageProduct: {
    _$s: {},
    _isPageProduct: false,
    _isProductAvailable: false,
    _locationDetails: null,
    _variantsIdSku: null,
    _invalidLocationIds: ['0251', '0271', '0272'],
    isProductAvailable: function() {
      let product = null;
      if ((!Shopify) || (!Shopify.metafieldsProduct)) { return; }
      product = Shopify.metafieldsProduct;
      if ((!product) || (!product.available)) { return; }
      return product.available;
    },
    appendVariantsToLocations: function() {
      let locationDetailsRaw = null;
      let locationDetails = null;
      if ((!Shopify) || (!Shopify.metafieldsLocationDetails)) { return; }
      locationDetailsRaw = Shopify.metafieldsLocationDetails;
      locationDetails = Object.keys(locationDetailsRaw)
        .filter(key => (parseInt(key, 10) <= 1000) && (! this._invalidLocationIds.includes(key)))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: locationDetailsRaw[key]
          };
        }, {});
      let variants = null;
      if ((!Shopify) || (!Shopify.metafieldsVariants)) { return; }
      variants = Shopify.metafieldsVariants;  // set _variants
      Object.entries(locationDetails).map((l) => {
        const locId = l[0];
        Object.entries(variants).map((v) => {
          const variantId = v[0];
          if (! locationDetails[locId]) {
            locationDetails[locId] = {};
          }
          // init .variants when not exist
          if (! locationDetails[locId].variants) {
            locationDetails[locId].variants = [];
          }
          if (! locationDetails[locId].variants[variantId]) {
            locationDetails[locId].variants[variantId] = {};
          }
          // append variants info to locationDetails
          locationDetails[locId].variants[variantId].inventory = 0;  // init zero
          if ((!! v[1]) && (!! v[1].inventory) && (!! v[1].inventory[locId])) {
            locationDetails[locId].variants[variantId].inventory = v[1].inventory[locId];
          }
          locationDetails[locId].variants[variantId].availableToTry = false;
          if ((!! v[1]) && (!! v[1].availableToTry) && (!! v[1].availableToTry[locId])) {
            locationDetails[locId].variants[variantId].availableToTry = v[1].availableToTry[locId];
          }
        });
      });
      return locationDetails;
    },
    createVariantsIdToSkuTable: function() {
      let variantsInProd = null;
      if ((!Shopify) || (!Shopify.metafieldsProduct || (!Shopify.metafieldsProduct.variants))) { return; }
      variantsInProd = Shopify.metafieldsProduct.variants;
      let table = {};
      variantsInProd.map((v) => {
        table[v.id] = v.sku;
      });
      return table;
    },
    initPageProduct: function() {
      this._$s = $('body.template-product');
      this._isPageProduct = this._$s.length ? true : false;
      if (this._isPageProduct) {
        this._locationDetails = this.appendVariantsToLocations();  // set _locationDetails
        this._variantsIdSku = this.createVariantsIdToSkuTable();  // set _variantsIdSku
        this._isProductAvailable = this.isProductAvailable();  // set _isProductAvailable
      }
    },
    showAddress: function(text) {
      const $c = $('#user-zip-entry-pdp');
      if ($c.length) {
        $c.removeClass('has-error');
      }
      const $t = this._$s.find('.user-location-pdp');
      if ($t.length) {
        $t.text(text);
      }
      const $i = $('#user-location-manual-input-pdp');
      const zip = $.cookie('location_zip');
      if ($i.length && zip) {
        $i.attr('placeholder', zip);
      }
      const $iHeader = $('#user-location-manual-input');
      if ($iHeader.length && zip) {
        $iHeader.val(zip);
      }
    },
    showErrorText: function(text) {
      const $c = $('#user-zip-entry-pdp');
      const $m = $('#user-zip-entry-pdp .error-message');
      if (!$c.length || !$m.length) { return; }
      $c.addClass('has-error');
      $m.html(`<span class="zip-error">${text}</span>`);
    },
    showZip: function(zip) {
      const $i = this._$s.find('#user-location-manual-input-pdp');
      if ($i.length) {
        $i.val(zip);
      }
    },
    showLoadingZip: function() {
      const $i = this._$s.find('.user-location-updating-icon-pdp');
      if (!$i.length) { return; }
      $i.fadeTo(300, 1);
    },
    hideLoadingZip: function() {
      if (! this._isPageProduct) { return; }
      const $i = this._$s.find('.user-location-updating-icon-pdp');
      if (!$i.length) { return; }
      $i.fadeTo(300, 0);
    },
    // init displayed address
    initAddressDisplayed: function() {
      const address = $.cookie('location_address');
      if (address) {
        this.showAddress(address);
      }
      const zip = $.cookie('location_zip');
      if (zip) {
        this.showZip(zip);
      }
    },
    // init section toggle
    initSectionToggle: function() {
      const $trigger = $('#toggle-zip-input-pdp');
      const $content = $('.purchasing-options-manual-zip');
      if (!$trigger.length || !$content.length) { return; }
      $content.hide();
      $trigger.on('click', function(e) {
        e.preventDefault();
        $content.slideToggle(300);
      });
    },
    // Set zip manually
    findLatLngFromZip: function(zip) {
      const exp = Shopify.InvtHelper.Cookie._Exp;
      this.showLoadingZip();
      Shopify.InvtHelper.GoogleGeo.lookupLatLng(zip)
        .then((response) => {
          const found = response.results.find(entry => entry.types && entry.types.includes('postal_code'));
          if (!found) {
            throw new Error('postal_code not found');
          }
          if (!found.geometry || !found.geometry.location) {
            throw new Error('geometry not found');
          }
          const latitude = found.geometry.location.lat;
          const longitude = found.geometry.location.lng;
          if (!found.address_components) {
            throw new Error('address_components not found');
          }
          const locality = found.address_components.find(component => component.types && component.types.includes('locality'));
          const state = found.address_components.find(component => component.types && component.types.includes('administrative_area_level_1'));
          if (!locality.short_name || !state.short_name) {
            throw new Error('locality or state not found');
          }
          const address = `${locality.short_name} ${state.short_name} ${zip}`;
  
          $.cookie('location_latitude', latitude, { path: '/', expires: exp });
          $.cookie('location_longitude', longitude, { path: '/', expires: exp });
          $.cookie('location_address', address, { path: '/', expires: exp });
          $.cookie('location_zip', zip, { path: '/', expires: exp });
          Shopify.InvtHelper.PurchasingOptions.updateDisabledMessageWithZip();
  
          Shopify.InvtHelper.Header.showAddress(address);
          
          // SUCCESS chain call
          this.showAddress(address);
          this.showZip(zip);
          this.hideLoadingZip();
          this.updateLocations();
        })
        .catch((e) => {
          console.log(e);
          switch(e.message) {
            case 'postal_code not found':
              this.showErrorText(`${zip} is not a valid Zip code. Please try again.`);
              break;
            case 'geometry not found':
            case 'address_components not found':
            case 'locality or state not found':
            default:
              this.showErrorText(`${e.message}. Entered value: ${zip}`);
              break;
          }
          this.hideLoadingZip();
        });
    },
    // only allow numeric key or Enter key
    initInputRestriction: function(e) {
      const $i = $('#user-location-manual-input-pdp');
      if (!$i.length) { return; }
      // keypress handler
      $i.on('keypress', (e) => {  // use arrow func to bind this
        // remove error css class if exists
        const $c = $('#user-zip-entry-pdp');
        if ($c.length) {
          $c.removeClass('has-error');
        }
        // evaluate keycode
        const keycode = (e.keyCode ? e.keyCode : e.which);
        if ((keycode != 13) && String.fromCharCode(keycode).match(/[^0-9]/g)) {
          return false;  // not Enter key and not numeric
        }
        if (keycode != '13') { return; }  // simply return if numeric
        e.preventDefault();  // pevent add-to-cart form submission
        const zip = $i.val();
        this.findLatLngFromZip(zip);
      });
    },
    // init manual zip submit button
    initSubmit: function(e) {
      const $b = $('.user-location-manual-submit');
      const $i = $('#user-location-manual-input-pdp');
      if (!$b.length || !$i.length) { return; }
      $b.on('click', (e) => {  // use arrow func to bind this
        e.preventDefault();  // pevent add-to-cart form submission
        const zip = $i.val();
        this.findLatLngFromZip(zip);
      });
    },
    // process locations
    hasLocationsNearby: function(userLat, userLng) {
      if (! this._locationDetails) { return; }  // check for metafields data
      // find locations within 2 degrees
      const latMin = userLat - 2;
      const latMax = userLat + 2;
      const lngMin = userLng - 2;
      const lngMax = userLng + 2;
      const locations = Object.entries(this._locationDetails).filter(a => 
        ((latMin <= a[1].lat) && (a[1].lat <= latMax))
        &&
        ((lngMin <= a[1].long) && (a[1].long <= lngMax))
      );
      return (!! locations.length);
    },
    calcCrow: function(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the earth in km
      const dLat = (lat2 - lat1) * Math.PI / 180;  // deg2rad below
      const dLon = (lon2 - lon1) * Math.PI / 180;
      let a = 
        0.5 - Math.cos(dLat)/2 + 
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
        (1 - Math.cos(dLon))/2;
      return R * 2 * Math.asin(Math.sqrt(a));
    },
    sortWithCrow: function(userLat, userLng) {
      if (! this._locationDetails) { return; }  // check for metafields data
      const locations = Object.entries(this._locationDetails).map(a => {
        a[1].crow = this.calcCrow(userLat, userLng, a[1].lat, a[1].long);
        return a;
      });
      locations.sort((a, b) => a[1].crow - b[1].crow);
      return locations;
    },
    setLocations: function() {
      const exp = Shopify.InvtHelper.Cookie._Exp;
      let userLat = $.cookie('location_latitude');
      let userLng = $.cookie('location_longitude');
      if (!userLat || !userLng) {
        // location service not available AND no location data in cookie
        Shopify.InvtHelper.PurchasingOptions.showEnterZipCode();
        return;  // return and do nothing
      } else {
        Shopify.InvtHelper.PurchasingOptions.hideEnterZipCode();
      }
      userLat = parseFloat(userLat);
      userLng = parseFloat(userLng);
      if (! this.hasLocationsNearby(userLat, userLng)) {
        $.removeCookie('locations', { path: '/' });  // clear cookie
        Shopify.InvtHelper.PurchasingOptions.setDeliveryAvailability();  // no near locations, but home delivery is
        Shopify.InvtHelper.PurchasingOptions.clearLocationList();
        return;
      }
      // pikcup locations available
      let locationFinals = this.sortWithCrow(userLat, userLng).slice(0, 10);
      if (! locationFinals) { return; }
      let locationFinalIds = [];
      locationFinals.map((l) => {
        locationFinalIds.push(l[0]);
      });
      $.cookie('locations', JSON.stringify(locationFinalIds), { path: '/', expires: exp });

      // chaining call
      Shopify.InvtHelper.PurchasingOptions.setDeliveryAvailability();
      Shopify.InvtHelper.PurchasingOptions.updateLocationList();
    },
    initLocations: function() {
      if ($.cookie('locations')) {
        // pikcup locations available
        Shopify.InvtHelper.PurchasingOptions.setDeliveryAvailability();
        Shopify.InvtHelper.PurchasingOptions.updateLocationList();
        return;
      }
      this.setLocations();
    },
    updateLocations: function() {
      if (! this._isPageProduct) { return; }
      // cleanup cookie
      if ($.cookie('locations')) {
        $.removeCookie('locations', { path: '/' });  // clear cookie
      }
      this.setLocations();
    },
  },
  PurchasingOptions: {
    _$o: {},  // option control
    _$p: {},  // pickup list
    _$t: {},  // try list
    init: function() {
      this._$o = $('.purchasing-option');
      this._$p = $('.pickup-locations');
      this._$t = $('.try-locations');
      Shopify.InvtHelper.PurchasingOptions.updateDisabledMessageWithZip();
    },
    updateDisabledMessageWithZip: function() {
      const zip = $.cookie('location_zip');
      if (!zip) { return; }
      const newDisabledMsg = `Not available near ${zip}`;
      // update Zip information in the disabled message
      this._$o.filter('#option-pickup').find('.option-content-disabled').html(newDisabledMsg);
      this._$o.filter('#option-try').find('.option-content-disabled').html(newDisabledMsg);
    },
    showEnterZipCode: function() {
      // remove disabled, add enterzip
      this._$o.siblings('#option-deliver').removeClass('disabled').addClass('enterzip');;
      // cleanup result
      this._$o.siblings('#option-deliver').find('.option-date').removeClass('loading has-result');
      this._$o.siblings('#option-deliver').find('.option-date .result').html('');
    },
    hideEnterZipCode: function() {
      // remove both disabled and enterzip
      this._$o.siblings('#option-deliver').removeClass('disabled enterzip');
      // cleanup result
      this._$o.siblings('#option-deliver').find('.option-date').removeClass('loading has-result');
      this._$o.siblings('#option-deliver').find('.option-date .result').html('');
    },
    setDeliveryAvailability: function() {
      if (Shopify.InvtHelper.PageProduct._isProductAvailable) {
        this._$o.siblings('#option-deliver').removeClass('disabled');
      } else {
        this._$o.siblings('#option-deliver').addClass('disabled');
      }
    },
    clearLocationList: function() {
      if (this._$p.length) {
        this._$o.siblings('#option-pickup').addClass('disabled');
        this._$p.slideUp();
        this._$p.empty();
        this._$o.siblings('#option-pickup').find('.option-date').addClass('loading');
        this._$o.siblings('#option-pickup').find('.option-date result').html('');
      }
      if (this._$t.length) {
        this._$o.siblings('#option-try').addClass('disabled');
        this._$o.siblings('#option-try').find('.option-location-count').html('');
        this._$t.slideUp();
        this._$t.empty();
      }
    },
    updateLocationList: function() {
      this._$o.siblings('#option-pickup').addClass('disabled');
      this._$o.siblings('#option-try').addClass('disabled');

      if (this._$p.length) {
        this._$o.siblings('#option-pickup').find('.option-date').addClass('loading');
        this._$o.siblings('#option-pickup').find('.option-date result').html('');
        this._$p.empty();
      }
      if (this._$t.length) {
        this._$o.siblings('#option-try').find('.option-location-count').html('');
        this._$t.empty();
      }

      let locationIds = null;
      let locations = [];
      if ($.cookie('locations')) {
        locationIds = JSON.parse($.cookie('locations'));
        locationIds.map((id) => {
          locations.push([id, Shopify.InvtHelper.PageProduct._locationDetails[id]]);
        });
        
        // debug locations before appending html
        //console.log(locations);

        const vId = Shopify.InvtHelper.Util.getUrlParameter('variant');

        const locationsPickup = locations.filter((loc) => loc[1].variants && loc[1].variants[vId] && (!! loc[1].variants[vId].inventory));
        const locationsTry = locations.filter((loc) => loc[1].variants && (!! Object.entries(loc[1].variants).filter(v => v[1] && v[1].availableToTry).length));

        if (locationsPickup.length) {
          this._$o.siblings('#option-pickup').removeClass('disabled');
          this._$o.siblings('#option-pickup').find('.option-date').removeClass('loading');
          const d = new Date();  // local date
          /* 
            const hours = d.getHours();  // evaluate with local time
          */
          // evaluate with EST time
          const utc = d.getTime() + (d.getTimezoneOffset() * 60000);  // utc
          const newyork = utc + (3600000 * (-5));  // EST time
          const dEst = new Date(newyork);  // EST date object
          const hours = dEst.getHours();
          let estimate = null;
          if (hours <= 16) {
            // before 4pm => today
            estimate = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'short', day: 'numeric'}).format(d);
          } else {
            // tomorrow
            estimate = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'short', day: 'numeric'}).format(d.setDate(d.getDate() + 1));
          }
          this._$o.siblings('#option-pickup').find('.option-date .result').html( estimate );
          locationsPickup.map((loc) => {
            let limitedQuantityHtml = '';
            if ((!!loc) && (!!loc[1]) && (!!loc[1].variants) && (!!loc[1].variants[vId]) && (!!loc[1].variants[vId].inventory)) {
              if (loc[1].variants[vId].inventory < 3) {
                limitedQuantityHtml = '<span class="limited-quantity-available">(Limited quantity available)</span>';
              }
            }
            const addressEncoded = encodeURI( loc[1].address );
            const linkGoogleMap = `https://www.google.com/maps/search/?api=1&query=${addressEncoded}`;
            const phoneRaw = (loc[1] && loc[1].phone) ? loc[1].phone : '1-877-959-7614';
            const phone = Shopify.InvtHelper.Util.formatPhoneNumber( phoneRaw );
            this._$p.append(`
              <div class="pickup-location" id="pickup-location-${loc[0]}">
                <div class="location-name">
                  Mattress Warehouse - <span class="">${loc[1].name}</span>
                  ${limitedQuantityHtml}
                </div>
                <div class="location-info">
                  <div class="location-address">
                    <a href="${linkGoogleMap}" target="_blank">
                      <span class="fa fa-map-marker"></span>
                      ${loc[1].address}
                    </a>
                  </div>
                  <div class="location-tel">
                    <a href="tel:1-877-959-7614">
                      <span class="fa fa-phone"></span>
                      ${phone}
                    </a>
                  </div>
                </div>
              </div>
            `);
          });
        }

        if (locationsTry.length) {
          this._$o.siblings('#option-try').removeClass('disabled');
          this._$o.siblings('#option-try').find('.option-location-count').html(locationsTry.length.toString());
          locationsTry.map((loc) => {
            const addressEncoded = encodeURI( loc[1].address );
            const linkGoogleMap = `https://www.google.com/maps/search/?api=1&query=${addressEncoded}`;
            const phoneRaw = (loc[1] && loc[1].phone) ? loc[1].phone : '1-877-959-7614';
            const phone = Shopify.InvtHelper.Util.formatPhoneNumber( phoneRaw );
            this._$t.append(`
              <div class="try-location" id="try-location-${loc[0]}">
                <div class="location-name">
                  Mattress Warehouse - <span class="">${loc[1].name}</span>
                </div>
                <div class="location-info">
                  <div class="location-address">
                    <a href="${linkGoogleMap}" target="_blank">
                      <span class="fa fa-map-marker"></span>
                      ${loc[1].address}
                    </a>
                  </div>
                  <div class="location-tel">
                    <a href="tel:1-877-959-7614">
                      <span class="fa fa-phone"></span>
                      ${phone}
                    </a>
                  </div>
                </div>
              </div>
            `);
          });
        }

        // automatically open prevously closed location list after swatch selection
        if (this._$o.siblings('#option-pickup').hasClass('selected')) {
          if (! this._$p.is(':visible')) {
            this._$p.slideDown();
          }
        } else if (this._$o.siblings('#option-try').hasClass('selected')) {
          if (! this._$t.is(':visible')) {
            this._$t.slideDown();
          }
        }
      }
    },
    initUiSwitch: function() {

      // init buttons
      this._$o.each((key, value) => {
        const that = this;
        $(value).on('click', function() {

          if ($(this).hasClass('disabled')) { return; }  // disable button

          $(this).addClass('selected');
          that._$o.not(this).removeClass('selected');

          if (this.id === 'option-deliver') {
            that._$p.hide();
            that._$t.hide();
          } else if (this.id === 'option-pickup') {
            that._$t.hide();
            that._$p.slideDown();
          } else if (this.id === 'option-try') {
            that._$p.hide();
            that._$t.slideDown();
          } else {
            that._$p.hide();
            that._$t.hide();
          }
        });
      });

      // Update locations when we click on swatches
      document.addEventListener('click', function (event) {
        if (!event.target.closest('.swatch .swatch-element')) return;
        event.preventDefault();
        setTimeout(function(){
          Shopify.InvtHelper.PageProduct.setLocations();
        }, 100);
      }, false);

      // estimate date for delivery
      const that = this;
      this._$o.siblings('#option-deliver').find('.estimate-date').on('click', function(e) {
        e.stopPropagation();
        that._$o.siblings('#option-deliver').find('.option-date').addClass('loading');
        Shopify.InvtHelper.Pickup.getAvailableDeliveryDate()
        .then((response) => {
          that._$o.siblings('#option-deliver').find('.option-date').removeClass('loading').addClass('has-result');
          if (response.deliveryDate) {
            console.log( response );
            const deliveryDate = new Date(response.deliveryDate);
            //console.log( deliveryDate.toLocaleString('en-US', { timeZone: 'GMT' }) );
            const estimateDate = new Intl.DateTimeFormat('en-US', { timeZone: 'GMT', weekday: 'long', month: 'short', day: 'numeric'}).format(deliveryDate);
            that._$o.siblings('#option-deliver').find('.option-date .result').html(estimateDate);
          } else {
            console.log( 'null returned from Storis api' );
            that._$o.siblings('#option-deliver').find('.option-date .result').html('<span class="delivery-not-available">Delivery not available</span>');
          }
        })
        .catch((e) => {
          console.log(e);
        });
      });

      // show enter zip
      this._$o.siblings('#option-deliver').find('.please-enter-zip').on('click', function(e) {
        e.stopPropagation();

        const $content = $('.purchasing-options-manual-zip');
        if (!$content.length) { return; }
        $content.slideDown(300);
      });
    },
  },
};

// --------------------------------------
// Header
// --------------------------------------

(function($) {

  $(document).ready(function() {

    // initilaize manual zip entry
    Shopify.InvtHelper.Header.initInputRestriction();
    Shopify.InvtHelper.Header.initSubmit();
    
    if (!!$.cookie('location_address')) {
      // location found in cookie
      Shopify.InvtHelper.Header.showAddress($.cookie('location_address'));
    } else {
      // attempt to set location
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          Shopify.InvtHelper.Header.findZipFromLatLng(position.coords.latitude, position.coords.longitude);
        });
      }
    }
  });

}(jQuery));

// --------------------------------------
// PDP
// --------------------------------------

(function($) {

  // detect product page
  Shopify.InvtHelper.PageProduct.initPageProduct();
  if (! Shopify.InvtHelper.PageProduct._isPageProduct) { return; }
  if (! Shopify.InvtHelper.PageProduct._isProductAvailable) { return; }

  // main

  Shopify.InvtHelper.PageProduct.initAddressDisplayed();

  Shopify.InvtHelper.PageProduct.initSectionToggle();

  Shopify.InvtHelper.PageProduct.initInputRestriction();
  Shopify.InvtHelper.PageProduct.initSubmit();

  $(window).load(function() {
    Shopify.InvtHelper.PurchasingOptions.init();
    Shopify.InvtHelper.PurchasingOptions.initUiSwitch();
    Shopify.InvtHelper.PageProduct.initLocations();
  });

}(jQuery));
